import { capitalCategoricalPalette } from "../../capitalCategoricalPalette.js";
const MuiLineChart = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
export {
  MuiLineChart
};
//# sourceMappingURL=MuiLineChart.js.map
